
<template>
  <v-app id="searchFcti">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Invoice line items</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(fctiRecord,i) in searchFcti" :key="i">
           <tr @click="$router.reload('/syst/ref/fcti/onFcti/' + fctiRecord.fcti_encrid)">
             <td>{{fctiRecord.fcti_type}}</td>
             <td>{{fctiRecord.fcti_rb}}</td>
             <td>{{fctiRecord.fcti_code}}</td>
             <td>{{fctiRecord.fctitaal_oms}}</td>
             <td>{{fctiRecord.fctitaal_oms_intern}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>    
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchFcti: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/fcti/searchFcti.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchFcti"
          },
          searchFcti: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchFcti = res.data.searchFcti;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
